<template>
    <div class="grid grid-cols-1 md:grid-cols-3 gap-4 p-2 py-6">
        <div>
            <h2 class="text-lg font-[500]">{{ $t("settings.auto.cambio_de_contrasena") }}</h2>
            <p class="text-sm pt-4">{{ $t("settings.auto.es_recomendable_usar_una_contrasena_larga_y_alea") }}</p>
        </div>

        <div class="flex flex-col gap-4 px-4">
            <div class="flex flex-col gap-y-2">
                <input 
                :type="inputTypeCurrentPassword" 
                name="currentPassword" 
                class="rounded-md text-sm  right-1 focus:ring-blue-400"
                :placeholder="$t('settings.auto.contrasena_actual')"
                v-model="changePasswordForm.currentPassword"
                v-bind:class="{'ring-red-400':errors.length > 0 && errors.find(e => e.currentPassword )}">

                <p class="text-xs md:text-sm text-red-400 pl-2" v-if="errors.length > 0 && errors.find(e => e.currentPassword)">
                    {{ errors.find(e => e.currentPassword).currentPassword }}
                </p>
            </div>
            <div class="flex flex-col gap-y-2">
                <input type="password" 
                name="newPassword" 
                class="rounded-md text-sm  right-1 focus:ring-blue-400"
                :placeholder="$t('settings.auto.contrasena_nueva')"
                v-model="changePasswordForm.newPassword"
                v-bind:class="{'ring-red-400':errors.length > 0 && errors.find(e => e.newPassword)}">

                <p class="text-xs md:text-sm text-red-400 pl-2" v-if="errors.length > 0 && errors.find(e => e.newPassword)">
                    {{ errors.find(e => e.newPassword).newPassword }}
                </p>
            </div>
        </div>

        <div class="mt-auto flex items-end px-4">
            <button 
            type="button"
            class="bg-green-500 text-white px-2 py-1.5 text-sm rounded-md mb-2 disabled:opacity-60"
            :disabled="loading"
            @click="updatePassword()"
            >
                <span class="animate animate-bouncing" v-if="loading">{{ $t("settings.auto.actualizando") }}</span>
                <span v-else>{{ $t("settings.auto.actualizar") }}</span>
            </button>
        </div>
    </div>
</template>

<script>
import usersRequests from '@/services/admin/users-service';
import { PASSWORD_ERROR_KEYS, resolvePasswordErrorKey } from '@/domains/auth';
import { useToast } from 'vue-toastification';

const FIELD_BY_ERROR_KEY = {
    [PASSWORD_ERROR_KEYS.currentPasswordInvalid]: 'currentPassword',
    [PASSWORD_ERROR_KEYS.invalidPassword]: 'newPassword',
};

export default {
    props:['userId'],
    data(){
        return {
            errors:[],
            changePasswordForm:{
                currentPassword:"",
                newPassword:""
            },
            loading:false,
            toast:useToast(),
            inputTypeCurrentPassword:'password'
        }
    },
    methods:{
        async updatePassword(){
            if (this.loading) return;
            this.loading = true;
            this.errors = [];
            try {
                const response = await usersRequests.updatePassword(this.userId, { ...this.changePasswordForm });
                const status = response?.status;
                if (status >= 200 && status < 300) {
                    this.toast.success(this.$t("settings.auto.contrasena_actualizada_correctamente"));
                    this.changePasswordForm.currentPassword = "";
                    this.changePasswordForm.newPassword = "";
                } else {
                    this.toast.error(this.$t(PASSWORD_ERROR_KEYS.generic));
                }
            } catch (error) {
                this.handleError(error);
            } finally {
                this.loading = false;
            }
        },
        handleError(error){
            const errorKey = resolvePasswordErrorKey(error);
            const message = this.$t(errorKey);
            const field = FIELD_BY_ERROR_KEY[errorKey];
            const validationErrors = error?.response?.data?.message;

            if (field) {
                this.errors = [{ [field]: message }];
            } else if (error?.response?.status === 400 && Array.isArray(validationErrors)) {
                this.errors = validationErrors;
            }

            this.toast.error(message);
        }
    }
}
</script>

<style lang="scss" scoped>

</style>